import {toast} from "react-toastify";
import CONST from "../const";

const ValidationInjured = (injured  , insuranceType , alarm = true) => {
    let list = CONST.INJURED_LIST


    for(let i = 0 ; i < list?.length ; i++ ) {
        let names = list[i]
        let emptyElement = document.querySelector("[name=" + names + "]")
        if(emptyElement)
            emptyElement.classList.remove("red")
    }

    for(let i = 0 ; i < injured?.length ; i++) {

        if(+injured[i].car_type_injered === 5) {
            list = CONST.INJURED_LIST_OTHER
        }
        if(insuranceType === 1 && +injured[i].car_type_injered !== 5) {
            list = CONST.INJURED_LIST_SALES
        }



        if(Object.keys(injured[i])?.length !== 0) {
            let nullList = Object.entries(injured[i])?.filter((item) => {

                return item[1] === null || item[1] === undefined || item[1] === false || item[1] === -1 || item[1] === "-1"  || item[1]?.toString()?.includes(undefined)  || item[1]?.toString()?.includes(null) || item[1] === ""
            })

            const contains = nullList.filter(element => {
                return list?.includes(element[0]);
            });

            if(contains?.length > 0) {
                for(let i = 0 ; i < contains?.length ; i++ ) {
                    let names = contains[i][0]
                    let emptyElement = document.querySelector("[name=" + names + "]")
                    if(emptyElement && alarm)
                        emptyElement.classList.add("red")
                }
                if(alarm)
                toast.error("لطفا تمام موارد اجباری  را وارد نمایید")
                return false
            }
        } else {
            toast.error("تغییری صورت نگرفته است")
            return false
        }
    }
    return true

}

export default ValidationInjured